import { ThemePreset } from '@/types';

export const themePresets: ThemePreset[] = [
  {
    id: 'classic',
    name: 'Classic',
    description: 'Elegant black and white with timeless serif typography',
    primary_color: '#1F2937',
    secondary_color: '#6B7280',
    accent_color: '#D4AF37',
    font_family: 'Playfair Display',
    background: '#FFFFFF',
  },
  {
    id: 'garden',
    name: 'Garden',
    description: 'Floral greens and soft pinks for a natural feel',
    primary_color: '#166534',
    secondary_color: '#EC4899',
    accent_color: '#F9A8D4',
    font_family: 'Cormorant Garamond',
    background: '#FDF2F8',
  },
  {
    id: 'sunset',
    name: 'Sunset',
    description: 'Warm oranges and rich purples for a vibrant mood',
    primary_color: '#EA580C',
    secondary_color: '#7C3AED',
    accent_color: '#FBBF24',
    font_family: 'Montserrat',
    background: '#FFFBEB',
  },
  {
    id: 'ocean',
    name: 'Ocean',
    description: 'Cool blues and teals inspired by the sea',
    primary_color: '#0369A1',
    secondary_color: '#0D9488',
    accent_color: '#67E8F9',
    font_family: 'Inter',
    background: '#F0F9FF',
  },
  {
    id: 'midnight',
    name: 'Midnight',
    description: 'Dark navy with gold accents for an opulent feel',
    primary_color: '#1E3A5F',
    secondary_color: '#2D4A7A',
    accent_color: '#D4AF37',
    font_family: 'Playfair Display',
    background: '#0F172A',
  },
  {
    id: 'rustic',
    name: 'Rustic',
    description: 'Warm earth tones with natural charm',
    primary_color: '#78350F',
    secondary_color: '#92400E',
    accent_color: '#D97706',
    font_family: 'Lora',
    background: '#FFFBEB',
  },
];

export const fontOptions = [
  { value: 'Inter', label: 'Inter (Modern Sans)' },
  { value: 'Playfair Display', label: 'Playfair Display (Elegant Serif)' },
  { value: 'Lora', label: 'Lora (Warm Serif)' },
  { value: 'Montserrat', label: 'Montserrat (Clean Sans)' },
  { value: 'Cormorant Garamond', label: 'Cormorant Garamond (Classic Serif)' },
];
